/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true } }] */
import Vue          from 'vue'
import Router       from 'vue-router'

// Pages
import Client       from '../pages/ClientPage'
import Clients      from '../pages/ClientsPage'
import CreateClient from '../pages/CreateClientPage'
import CreateUser   from '../pages/CreateUserPage'
import Fund         from '../pages/FundPage'
import Rebalance    from '../pages/RebalancePage'
import Prices       from '../pages/PricesPage'
import Currencies   from '../pages/CurrenciesPage'
import Groups       from '../pages/GroupsPage'
import Home         from '../pages/HomePage'
import Users        from '../pages/UsersPage'

// AUTH Pages
import ChangePass   from '../pages/auth/ChangePassPage'
import Login        from '../pages/auth/LoginPage'
import ResetPass    from '../pages/auth/ResetPassPage'

import { store } from '../store'
import RouterGuard  from '@/router/guard'
const routerGuard = RouterGuard(store)

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/clients',
      name: 'Clients',
      component: Clients,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/clients/create',
      name: 'Create Client',
      component: CreateClient,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/clients/:id',
      name: 'Client',
      component: Client,
      beforeEnter: routerGuard.requireUser,
      props: true,
    },
    {
      path: '/users',
      name: 'Users',
      beforeEnter: routerGuard.requireUser,
      component: Users,
    },
    {
      path: '/users/create',
      name: 'CreateUser',
      component: CreateUser,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/groups',
      name: 'Groups',
      beforeEnter: routerGuard.requireUser,
      component: Groups,
    },
    // {
    //   path: '/users/create',
    //   name: 'CreateUser',
    //   component: CreateUser,
    //   beforeEnter: routerGuard.requireUser,
    // },
    {
      path: '/fund',
      name: 'Fund',
      component: Fund,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/rebalance',
      name: 'Rebalance',
      component: Rebalance,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/prices',
      name: 'Prices',
      component: Prices,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/currencies',
      name: 'Currencies',
      component: Currencies,
      beforeEnter: routerGuard.requireUser,
    },
    // AUTH
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: routerGuard.requireGuest,
    },
    {
      path: '/change',
      name: 'Change',
      component: ChangePass,
      beforeEnter: routerGuard.requireUser,
    },
    {
      path: '/reset/:id/:token',
      name: 'Reset',
      component: ResetPass,
      props: true,
      beforeEnter: routerGuard.requireGuest,
    },
    {
      path: '/setup/:id/:token',
      name: 'Setup',
      component: ResetPass,
      props: true,
      beforeEnter: routerGuard.requireGuest,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/-service-app/router/index.js